<template>
    <div class="p-2" style="width:250px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ initialMuckType }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
        <vs-row class="mt-2">
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.MuckType.Title')}}</form-label>
            <v-select
              label="name"
              :options="muckTypes"
              :reduce="type => type.muckTypeId"
              v-model="muckTypeId"
              @input="setType"
              class="w-full"
              name="muckType"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "../../../../shared/components";

export default {
  name: 'MuckTypeCellEditor',
  data() {
    return {
      muckTypeId: null
    }
  },
  computed: {
    initialMuckType() {
      if (!this.params.value || this.params.value.muckType === null) {
        return ""
      }
      const muckType = this.params.context.componentParent.muckTypes.find(m => m.muckTypeId === this.muckTypeId);
      return muckType ? muckType.name : "";
    },
    muckTypes() {
      return this.params.context.componentParent.muckTypes;
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.muckTypeId = this.params.value ? this.params.value.muckTypeId : null;
  },
  methods: {
    getValue() {
      const selectedMuckType = this.params.context.componentParent.muckTypes.find(m => m.muckTypeId === this.muckTypeId);
      return {
        muckTypeId: this.muckTypeId,
        muckType: selectedMuckType ? selectedMuckType.name : null
      };
    },
    isPopup() {
      return true;
    },
    setType(type) {
      this.muckTypeId = type;
    }
  }
}
</script>
